export const mainContainer = {
    margin: '0 auto',  
    width: '100%',  
    '@media(max-width: 1023px)': {
        width: '100%'
    },
    '@media(min-width: 1440px)': {
        maxWidth: '1440px'
    }
};